import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoLogOutOutline } from 'react-icons/io5';
import { CgProfile } from "react-icons/cg";
import { clearAuthData, logoutState } from '../../Redux/AuthSlice';
import { api_url } from '../../config';
import { toast } from 'react-toastify';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const RetailHeader = ({ isSidebarVisible, toggleSidebar }) => {
    const [branchName, setBranchName] = useState('');
    const dispatch = useDispatch();
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const { first_name, last_name, branch_id, id } = useSelector((state) => state.auth)
    const token = useSelector((state) => state.auth.token)

    useEffect(() => {
        const fetchBranchName = async () => {
            try {
                const response = await axios.get(`${api_url}/api/v1/retailer/user/${id}/branch/${branch_id}/user-profile-single`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.data && response.data.data && response.data.data.branch && response.data.data.branch.name) {
                    setBranchName(response.data.data.branch.name);
                }
            } catch (error) {
                console.error('Error fetching user profile:', error);
                console.error('Error details:', {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status
                });
            }
        };

        if (branch_id && id) {
            fetchBranchName();
        }
    }, [branch_id, id, token]);

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
            dispatch(logoutState(true))
            await axios.post(api_url + '/api/retailer/logout', {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            dispatch(clearAuthData());

            // Manipulate the browser's history to prevent going back to protected pages
            window.history.pushState(null, '', '/login');
            window.onpopstate = () => {
                window.history.pushState(null, '', '/login');
            };
            dispatch(logoutState(false))
            toast.success('Logout successful')
            // Navigate to the login page
            navigate('/login', { replace: true });
        } catch (error) {
            console.error('Logout error:', error);
            // Handle error if needed
        }
    };

    const navigate = useNavigate()

    const toggleDropdown = () => {
        setDropdownVisible(!isDropdownVisible);
    };

    const dropdownRef = useRef(null);
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    function getInitials(name) {
        const words = name?.split(' ');
        const firstNameInitial = words?.[0]?.charAt(0).toUpperCase();
        const lastNameInitial = words?.[words.length - 1]?.charAt(0).toUpperCase();
        return firstNameInitial + lastNameInitial;
    }
    const name = `${first_name} ${last_name}`
    const initials = getInitials(name);

    return (
        <div className='bg-white border-b border-gray-100 shadow-md font-lufga'>
            <div className='flex justify-between items-center px-2 py-2.5'>
                <div className='flex items-center gap-3'>
                    {/* <img src={rlogo} className='rounded-lg shadow-sm w-9 h-9' alt="Pharmtrix Logo" /> */}
                    <button
                        onClick={toggleSidebar}
                        className="p-2 transition-colors duration-200 bg-green-700 rounded-full"
                        aria-label={isSidebarVisible ? "Hide Sidebar" : "Show Sidebar"}
                    >
                        {isSidebarVisible ? (
                            <FiChevronLeft size={20} className="text-white" />
                        ) : (
                            <FiChevronRight size={20} className="text-white" />
                        )}
                    </button>
                    <div className="flex flex-col">
                        <h1 className="text-base font-medium text-gray-700 sm:text-lg">
                            Welcome, <span className="font-bold text-green-600">{first_name} {last_name}</span>
                        </h1>
                        <p className="hidden md:block text-sm text-black/80 mt-0.5">
                            Branch: <span className="font-medium leading-snug text-black/80">{branchName}</span>
                        </p>
                    </div>
                </div>
                <div className='flex items-center gap-3'>
                    <div className='relative font-lufga' ref={dropdownRef}>
                        <button
                            className='px-2.5 py-1.5 border border-gray-200 h-9 w-9 rounded-full text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200 flex items-center justify-center shadow-sm hover:shadow-md'
                            onClick={toggleDropdown}
                            aria-label="User menu"
                        >
                            {initials}
                        </button>
                        {isDropdownVisible && (
                            <div className='absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1.5 z-50'>
                                <Link to='/retail/profile' className='block px-3 py-2 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-50'>
                                    <div className='flex items-center gap-2.5'>
                                        <CgProfile size={18} className="text-green-600" />
                                        <span>Profile</span>
                                    </div>
                                </Link>
                                <button
                                    onClick={handleLogout}
                                    className='w-full px-3 py-2 text-sm text-left text-gray-700 transition-colors duration-200 hover:bg-gray-50'
                                >
                                    <div className='flex items-center gap-2.5'>
                                        <IoLogOutOutline size={18} className="text-green-600" />
                                        <span>Logout</span>
                                    </div>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RetailHeader;
